// extracted by mini-css-extract-plugin
module.exports = {"notification_table":"Notifications--notification_table--3M19U","item_title":"Notifications--item_title--1G5K0","action_area":"Notifications--action_area--zcMkZ"};